import { render, staticRenderFns } from "./ThirdPartyOccupants.vue?vue&type=template&id=27994e9a"
import script from "./ThirdPartyOccupants.vue?vue&type=script&lang=js"
export * from "./ThirdPartyOccupants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports